import { render, staticRenderFns } from "./CustomerLegalForm.vue?vue&type=template&id=362e02aa"
import script from "./CustomerLegalForm.vue?vue&type=script&lang=js"
export * from "./CustomerLegalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports